import { Label } from '@/components/ui/label';
import { useOverrideTaxonomyQuery } from '@/lib/api/overrides';

/**
 * The "Reason" picker for Approve as Noted, shared by the single-item note
 * step and the bulk bar so both offer the same reasons (T-0229 / C2-48).
 * Both read the server's override taxonomy; the single-item step used to
 * fall back to a lone "Other" option whenever the taxonomy had not loaded
 * (or its fetch had failed), which read as a shorter list. Now a missing
 * taxonomy says so, with a retry, instead of passing for the full list.
 * The default value stays "other", which the taxonomy always carries.
 */
export function ReasonTagSelect({
  id,
  value,
  onChange,
  disabled = false,
}: {
  id: string;
  value: string;
  onChange: (value: string) => void;
  disabled?: boolean;
}) {
  const taxonomy = useOverrideTaxonomyQuery();
  const tags = taxonomy.data?.tags;
  return (
    <>
      <Label htmlFor={id} className="text-muted-foreground">
        Reason
      </Label>
      <select
        id={id}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        disabled={disabled || !tags}
        className="rounded-md border bg-background px-2 py-1 text-xs"
      >
        {tags ? (
          tags.map((t) => (
            <option key={t.key} value={t.key}>
              {t.label}
            </option>
          ))
        ) : (
          <option value={value}>
            {taxonomy.isError ? 'Reasons could not be loaded' : 'Loading reasons…'}
          </option>
        )}
      </select>
      {taxonomy.isError ? (
        <button
          type="button"
          onClick={() => void taxonomy.refetch()}
          className="text-xs font-medium text-primary hover:underline"
        >
          Retry
        </button>
      ) : null}
    </>
  );
}
